<template>
  <div>
    <template v-if="getId">
      <main-message-form />
    </template>
    <template v-else>
      <new-message-form />
    </template>
  </div>
</template>

<script>
import NewMessageForm from './components/NewMessageForm.vue'
import MainMessageForm from './components/MainMessageForm.vue'

export default {
  name: 'PreparedSentMessageForm',
  components: {
    NewMessageForm,
    MainMessageForm,
  },
  computed: {
    getId() {
      return this.$route.params.id || null
    },
  },
}
</script>

<style>
</style>